module.exports = __webpack_public_path__ + "img/money.302ed036.png";